import React, { useEffect, useState } from 'react';
import axios from 'axios';

export const BotFeeNotice = () => {
  const [policy, setPolicy] = useState(null), [failed, setFailed] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/bot-fee-policy`, { signal: controller.signal })
      .then(response => { if (!controller.signal.aborted) setPolicy(response.data); })
      .catch(() => { if (!controller.signal.aborted) setFailed(true); });
    return () => controller.abort();
  }, []);
  return <p className="text-xs text-slate-300 border-l-2 border-teal-600 pl-3 mt-4 leading-relaxed" data-testid="social-bot-fee-policy" role={failed ? 'alert' : 'status'}>
    {failed ? 'Bot fee policy is unavailable. No automatic fee collection is enabled.' : policy ? `Configured bot fee: ${policy.rate_bps / 100}% of positive realized net profit only. Collection is not enabled; paper trades are exempt. No automatic transfers to the master wallet are verified.` : 'Loading bot fee policy…'}
  </p>;
};